import * as util from 'biojs/Util';
import {Sequence} from 'components/Sequence';
import Annotation from 'molbio/annotations/backbone/Annotation';
import {Feature} from 'molbio/feature-libraries/FeatureLibrary';
import {FeatureLibrary} from 'molbio/feature-libraries/FeatureLibraryConstants';
import EntityStore from 'stores/EntityStore';

export function formatFeatureLibraryName(library: FeatureLibrary): string {
  return library.owner_handle === EntityStore.currentUser().handle
    ? library.name
    : `${library.owner_handle} / ${library.name}`;
}

export function createFeature({
  name,
  featureType,
  bases,
  color,
  matchType,
  libraryId,
}: {
  name: string;
  featureType: string;
  bases: string;
  color: string;
  matchType: 'protein' | 'nucleotide';
  libraryId: number;
}): JQueryXHR {
  const feature = new Feature({
    name,
    feature_type: featureType,
    bases,
    color,
    library_id: libraryId,
    match_type: matchType,
  });
  return feature.save();
}

export function createFromAnnotation(
  annotation: Annotation,
  sequence: Sequence,
  libraryId: number
): JQueryXHR {
  let bases = util.slice(
    sequence.get('dna').forward(),
    annotation.start(),
    annotation.end(),
    sequence.circular()
  );
  if (annotation.strand() === -1) {
    bases = util.revcomp(bases, sequence.get('_sequence').baseTable());
  }
  return createFeature({
    name: annotation.name(),
    featureType: annotation.annotationType(),
    bases,
    color: annotation.color(),
    libraryId,
    matchType: 'nucleotide',
  });
}
